/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const owl = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M3.125 2.196 8.01.866a.94.94 0 0 1 .491 0l4.878 1.33L8.5 3.528a.94.94 0 0 1-.494 0l-4.88-1.332Zm0 0-.767 2.498m9.015-.085V2.743m-6.258-.005v1.878m7.286 2.996c.272-.035.268-.011.53.069a1.946 1.946 0 0 1 1.38 1.842v1.283a3.242 3.242 0 0 1-3.423 3.206h-.108M4.04 7.497c-.269-.022-.27.011-.526.1a1.956 1.956 0 0 0-1.32 1.85v1.305a3.263 3.263 0 0 0 3.4 3.26h.13m0 0a3.728 3.728 0 0 0 5.164-.104c.7-.7.842-1.648.842-2.636V11m-6.96 0v.272c0 .988.146 1.937.845 2.636l.109.104m.198-7.454h.022m4.615 0h.023M6.813 8.462A2.102 2.102 0 1 0 5.03 4.655a2.102 2.102 0 0 0 1.784 3.807Zm0 0 1.439 2.358L9.69 8.461m0 0a2.102 2.102 0 1 0 1.782-3.808A2.102 2.102 0 0 0 9.69 8.461Z"
    />
  </svg>
)
export default owl
